/**
 * NATIVE APP SHELL — no-op for web and portal builds.
 *
 * `vite --mode capacitor` (npm run build:app) resolves this module to `native-app-capacitor.js`
 * instead (see `capacitorNativeAppPlugin` in vite.config.js). Keeping Capacitor and device-motion
 * code out of portal bundles means portals (Poki, CrazyGames, …) never see motion permission
 * warnings in the console. Browser vibration lives in `vibration.js`, gated so it never warns.
 */

export const NativeApp = {
  /** @returns {boolean} true only inside the Capacitor iOS / Android app. */
  isEnabled: function () {
    return false;
  },

  /**
   * Native haptics player, phone-shake → SHAKE, Android back, iOS audio session, app lifecycle.
   * @param {{ game: object }} _opts
   */
  install: function (_opts) {},

  /** The HTML loader has painted — hand over from the native launch splash. */
  hideLaunchSplash: function () {},
};
